import { getUrlByQueryParameterObj } from './queryStringFunctions';
import { getLoginPageUrlObject } from 'routes/account';
import { LOCAL_STORAGE_KEY_LOGGED_IN } from '@store/user';
import qs from 'qs';
const getUrlPath = url => {
  const {
    pathname,
    query
  } = url;
  return pathname + getUrlByQueryParameterObj('', query);
};
export const redirectToUrl = url => {
  if (window.location.pathname.replace(/\/$/, '') === url.pathname.replace(/\/$/, '')) {
    return;
  }
  window.location.replace(getUrlPath(url));
};
export const redirectToLoginPage = (loginPageType, includeRedirect) => {
  localStorage.removeItem(LOCAL_STORAGE_KEY_LOGGED_IN);
  redirectToUrl(getLoginPageUrlObject({
    loginPageType: loginPageType,
    redirectUrl: includeRedirect ? window.location.pathname + window.location.search : null
  }));
};
export const queryToArray = queryValue => {
  return queryValue ? queryValue.split(',') : undefined;
};
export const urlObjectToString = urlObject => {
  const {
    pathname,
    query
  } = urlObject;
  if (!query || Object.keys(query).length === 0) {
    return pathname;
  }
  const queryString = qs.stringify(query, {
    encode: false
  });
  return `${pathname}?${queryString}`;
};